import { Formik } from "formik";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, ModalBody, Row } from "reactstrap";
import { createAppointment } from "../../redux/actions/api/apiAction";
import { AppointmentForm } from "./appointmentForm";
import { AppointmentTitle } from "./modalTitle";
import { AppointmentSchema } from "./utils";
import _ from "lodash";
import { addServiceModal } from "../../redux/actions/sidebar/sidebarAction";
import { toastr } from "react-redux-toastr";
import {
  saveVoiceDraftEdit,
  voiceReviewActionLabel,
} from "../voiceAdd/saveDraftEdit";
import { withVoicePrefill } from "../voiceAdd/openForm";

export const AddAppointment = ({ toggleModal }) => {
  let name = useMemo(() => "", []),
    packages = useMemo(() => [], []),
    price = useMemo(() => "", []),
    trainers = useMemo(() => [], []),
    allowOnlineBooking = useMemo(() => false, []),
    allowCancelation = useMemo(() => false, []),
    allowUnpaidBooking = useMemo(() => false, []),
    noShowDeduction = useMemo(() => false, []),
    description = useMemo(() => "", []),
    payRates = "",
    appointmentType = null;
  const { serviceModal } = useSelector((state) => state.sidebar);
  const { loading } = useSelector((state) => state.gym);
  const voicePrefill = useSelector(
    (state) => state.voiceAdd && state.voiceAdd.prefill
  );
  const voiceFields =
    voicePrefill && voicePrefill.type === "appointment"
      ? voicePrefill.fields || {}
      : {};
  const voiceScalarFields = Object.keys(voiceFields).reduce((result, key) => {
    if (key !== "trainers" && key !== "packages") {
      result[key] = voiceFields[key];
    }
    return result;
  }, {});
  const voiceOptions = (key) =>
    (Array.isArray(voiceFields[key]) ? voiceFields[key] : []).map((item) => ({
      ...item,
      value:
        item && item.value !== undefined
          ? item.value
          : item && (item.id || item.pending),
      key: item && (item.pending || item.id || item.value),
      label: (item && (item.label || item.name)) || "",
      count: (item && item.count) || 1,
      sessionCount: (item && (item.sessionCount || item.count)) || 1,
      price: (item && item.price) || 0,
      appointments: (item && item.appointments) || [],
    }));

  const { gym } = useSelector((state) => state.gym);
  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    if (saveVoiceDraftEdit(values)) return;
    const req = _.cloneDeep(values);
    req.packages.forEach((pack, idx) => {
      req.packages[idx] = {
        id: pack.value || pack.id,
        count: pack.count || parseInt(pack.sessionCount),
      };
    });
    req.trainers = (req.trainers || [])
      .map((trainer) =>
        trainer && typeof trainer === "object"
          ? trainer.value || trainer.id
          : trainer
      )
      .filter((id) => id !== undefined && id !== null && id !== "");
    req.payrateId =
      req?.payRates && req?.payRates.lenght ? req?.payRates[0]?.id : null;
    req.appointmentType = req?.appointmentType && req?.appointmentType.value;
    console.log({ req });
    dispatch(createAppointment(req));
  };

  return (
    <>
      <AppointmentTitle
        title={
          gym.type == "sportClub" ? "Add Private Lesson" : "Add Appointment"
        }
        subTitle={
          gym.type == "sportClub"
            ? "Add info about Private Lesson "
            : "Add info about the Appointment"
        }
      />
      <ModalBody className="mx-4 py-5">
        <Formik
          validationSchema={AppointmentSchema}
          initialValues={withVoicePrefill("appointment", {
            name,
            displayName: "",
            image: "",
            duration: "",
            price,
            description,
            noShowDeduction,
            allowOnlineBooking,
            allowCancelation,
            allowUnpaidBooking,
            trainers: voiceOptions("trainers").length
              ? voiceOptions("trainers")
              : trainers,
            packages: voiceOptions("packages").length
              ? voiceOptions("packages")
              : packages,
            court: null,
            payRates: null,
            coachingType:null,
            ...voiceScalarFields,
          })}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, values, setFieldValue, handleChange }) => (
            <AppointmentForm
              values={values}
              setFieldValue={setFieldValue}
              errors={errors}
              touched={touched}
              handleChange={handleChange}
            />
          )}
        </Formik>
        <Row>
          <Col md={12} className="pl-0">
            <div className="action-wrapper blk-padding-y">
              <div className="action-inner-block">
                <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-medium btn-transparent mr-4"
                    onClick={() => {
                      toggleModal
                        ? toggleModal()
                        : serviceModal
                        ? dispatch(addServiceModal(false))
                        : toastr.error(
                            "Some error occured, please refresh the page"
                          );
                    }}
                  >
                    Cancel
                  </button>
                </React.Fragment>
                <button
                  className="btn btn-medium"
                  type="submit"
                  form="add-appointment"
                  disabled={loading}
                >
                  {voiceReviewActionLabel(
                    gym.type == "sportClub"
                      ? "ADD Private Lesson "
                      : "ADD APPOINTMENT"
                  )}
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </>
  );
};
